import { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import CheckIcon from "@mui/icons-material/Check";
import { useDispatchApp } from "../../../lib/redux";
import { startSaveAgencyName } from "../../../actions/owner";

const EditableAgencyName = ({ agencyID, value }) => {
  const dispatch = useDispatchApp();
  const [isEditing, setIsEditing] = useState(false);
  const [displayName, setDisplayName] = useState(value);
  const [text, setText] = useState(value);
  const containerRef = useRef(null);

  useEffect(() => {
    setDisplayName(value);
    setText(value);
  }, [value]);

  const onSave = () => {
    const trimmed = text.trim();
    const nextName = trimmed || displayName;

    if (trimmed && trimmed !== displayName) {
      dispatch(startSaveAgencyName({ agencyID, name: trimmed }));
      setDisplayName(trimmed);
    }

    setText(nextName);
    setIsEditing(false);
  };

  const onCancel = () => {
    setText(displayName);
    setIsEditing(false);
  };

  const onStartEditing = () => {
    setText(displayName);
    setIsEditing(true);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onSave();
    } else if (e.key === "Escape") {
      onCancel();
    }
  };

  useEffect(() => {
    const onClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        onSave();
      }
    };

    if (isEditing) {
      document.addEventListener("mousedown", onClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", onClickOutside);
    };
    // eslint-disable-next-line
  }, [isEditing, text, displayName]);

  if (isEditing) {
    return (
      <Box
        ref={containerRef}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          minWidth: 0,
          maxWidth: 250,
        }}
      >
        <Input
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={onKeyDown}
          autoFocus
          disableUnderline={false}
          sx={{
            fontSize: "0.875rem",
            fontWeight: 600,
            flex: 1,
            minWidth: 0,
            maxWidth: 250,
            "& .MuiInput-input": {
              py: 0,
            },
          }}
        />
        <IconButton size="small" onClick={onSave} sx={{ p: 0.25 }}>
          <CheckIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
    );
  }

  return (
    <Typography
      component="span"
      onClick={onStartEditing}
      sx={{
        fontSize: "0.875rem",
        fontWeight: 600,
        color: "#374151",
        cursor: "pointer",
        lineHeight: 1,
        display: "inline-block",
        borderBottom: "2px solid currentColor",
        pb: "1px",
        maxWidth: 250,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {displayName}
    </Typography>
  );
};

export default EditableAgencyName;
